import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { ALLOWED_ACTION, MODULE } from "../constants/constants";

type AllowedActions = {
  customerInfo?: string[];
  insuranceInfo?: string[];
  redemptionHistory?: string[];
  searchUser?: string[];
  unlockUser?: string[];
  unlinkUser?: string[];
};

type Permission = {
  userRole: string;
  module: string;
  dataLevel: string;
  countries: string[];
  allowedActions: AllowedActions;
};

type Permissions = {
  permission_Token: string;
  permissions: Permission[];
};

type PermissionState = {
  allowUnlockUser: boolean;
  permissionToken?: string;
  countries?: string[];
  ppsCountries?: string[];
  permissionEngage?: boolean;
  permissionCustomer?: boolean;
  permissionInventory?: boolean;
  permissionLeads?: boolean;
  permissionPPS?: boolean;
  permissionDNA?:boolean;
  permissionIntelligenceHub?: boolean;
  allowUnlinkUser: boolean;
  setPermission: (permission: Permissions) => void;
  permissions?: Permission[];
};

export const usePermissionStore = create(
  persist<PermissionState>(
    set => ({
      allowUnlockUser: false,
      permissionToken: undefined,
      allowUnlinkUser: false,
      setPermission: permission => {
        const permissionCustomer = permission?.permissions?.find(
          item => item.module === MODULE.CUSTOMER,
        );
        const permissionPps = permission?.permissions?.find(
          item => item.module === MODULE.PPS,
        );
        set({
          allowUnlockUser:
            !!permissionCustomer?.allowedActions?.unlockUser?.length &&
            permissionCustomer?.allowedActions?.unlockUser[0] ===
              ALLOWED_ACTION.RIGHTS,
        });
        set({
          allowUnlinkUser:
            !!permissionPps?.allowedActions?.unlinkUser?.length &&
            permissionPps?.allowedActions?.unlinkUser[0] ===
              ALLOWED_ACTION.RIGHTS,
        });
        set({ permissionToken: permission.permission_Token });
        set({ countries: permissionCustomer?.countries });
        set({
          permissionCustomer: !!permission.permissions?.find(
            item => item.module === MODULE.CUSTOMER,
          ),
        });
        set({
          permissionInventory: !!permission.permissions?.find(
            item => item.module === MODULE.INVENTORY,
          ),
        });
        set({
          permissions: permission.permissions,
        });
        set({
          permissionPPS: !!permission.permissions?.find(
            item => item.module === MODULE.PPS,
          ),
        });
        set({
          permissionLeads: !!permission.permissions?.find(
            item => item.module === MODULE.LEADS,
          ),
        });
        set({
          permissionIntelligenceHub: !!permission.permissions?.find(
            item => item.module === MODULE.INTELLIGENCE,
          ),
        });
         set({
          permissionDNA: !!permission.permissions?.find(
            item => item.module === MODULE.DNA,
          ),
        });
        set({
          permissionEngage: !!permission.permissions?.find(
            item => item.module === MODULE.ENGAGE,
          ),
        });
        set({ ppsCountries: permissionPps?.countries });
      },
    }),
    {
      name: "permission-storage",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
